export enum ActionIdEnum {
    None = 0,
    View = 1,
    Edit = 2,
    Delete = 3,
    OpenModal = 4,
    Notes = 5,
    Select = 6,
    Import = 7,
    Download = 8,
    Security = 9,
    EnableDisable = 10,
    CancelEditing = 11,
    ApproveEdits = 12,
    LoadChat = 13,
    LoadKnowledgeBase = 14,
    UnloadKnowledgeBase = 15,
    OCR = 16,
    Highlight = 17,
    DeleteVectorStore = 18,
    AssigneeManagement = 19
}